import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';

@Component({
  selector: 'app-presentacion',
  templateUrl: './presentacion.component.html',
  styleUrls: ['./presentacion.component.css']
})
export class PresentacionComponent implements OnInit {

  constructor( 
      private router:Router
  ) { }

  ngOnInit(): void {
  }

  salir(){
    this.router.navigateByUrl('https://redlarousse.mx/live/');
  }
}
